export const Footer = () => {
  return (
    <footer className="border-t border-[#27272a] px-6 py-12 sm:px-10 lg:px-16" data-testid="footer">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
        <div>
          <span className="text-lg font-black tracking-tight">Mirlos Company</span>
          <p className="mt-1 text-xs font-light text-[#71717a]">
            Guida gratuita · AI &amp; Instagram
          </p>
        </div>
        <p className="text-xs font-light text-[#71717a]">
          © {new Date().getFullYear()} Mirlos Company. Tutti i diritti riservati.
        </p>
      </div>
    </footer>
  );
};
